<div id="main-wrapper" [ngClass]="containerClass">
    <app-sidebar></app-sidebar>
    <div class="layout-mask" *ngIf="layoutService.state.staticMenuMobileActive" (click)="hideMenu()"></div>
    <div class="page-wrapper">
        <app-topbar></app-topbar>
        <div class="body-wrapper pb-5">
           <div class="layout-content">
             <router-outlet></router-outlet>
           </div>
        </div>
    </div>
</div>
